import { render } from "./Home.vue?vue&type=template&id=07f8192c"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=07f8192c&lang=scss"

import exportComponent from "/home/callum/Documents/CODE/raphaelschoen/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__